export enum FileType {
  PDF, CSV
}


export interface IFile {
  file: string
  fileName: string
  fileType: FileType
}
